import styles from './Checkbox.module.scss'
import { DefaultCheckedIcon, DefaultIcon } from './icons'

interface CheckboxProps {
  checked: boolean
  onClick?: (checked: boolean) => void
}

const Checkbox = ({ checked, onClick }: CheckboxProps) => (
  <div className={styles.checkbox} onClick={onClick ? () => onClick(checked) : undefined}>
    {checked ? <DefaultCheckedIcon /> : <DefaultIcon />}
  </div>
)

export default Checkbox
